(function(){
  'use strict';

  function money(cents, currency){
    try{
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style:'currency', currency: currency
      }).format((cents||0)/100);
    }catch(e){
      return (cents/100).toFixed(2);
    }
  }

  function ready(fn){
    if(document.readyState !== 'loading'){ fn(); }
    else{ document.addEventListener('DOMContentLoaded', fn); }
  }

  /* ---------- CART DRAWER (shared, theme-wide) ---------- */
  var Cart = {
    currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
    drawer: null, ov: null, body: null, sub: null, counts: [],
    init: function(){
      this.drawer = document.getElementById('sable-drawer');
      this.ov     = document.getElementById('sable-ov');
      if(!this.drawer) return;
      this.body   = this.drawer.querySelector('[data-cart-items]');
      this.sub    = this.drawer.querySelector('[data-cart-subtotal]');
      this.counts = Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]'));
      var self = this;

      document.querySelectorAll('.js-open-cart').forEach(function(b){
        b.addEventListener('click', function(e){ e.preventDefault(); self.open(); });
      });
      this.drawer.querySelectorAll('.js-close-cart').forEach(function(b){
        b.addEventListener('click', function(){ self.close(); });
      });
      if(this.ov) this.ov.addEventListener('click', function(){ self.close(); });
      document.addEventListener('keydown', function(e){ if(e.key==='Escape') self.close(); });

      this.body.addEventListener('click', function(e){
        var rm = e.target.closest('[data-remove]');
        if(rm){ e.preventDefault(); self.change(rm.getAttribute('data-remove'), 0); }
      });

      this.refresh();
    },
    open: function(){ if(this.ov)this.ov.classList.add('show'); this.drawer.classList.add('show'); },
    close: function(){ if(this.ov)this.ov.classList.remove('show'); this.drawer.classList.remove('show'); },
    setCount: function(n){ this.counts.forEach(function(c){ c.textContent = n; }); },
    render: function(cart){
      this.currency = cart.currency || this.currency;
      this.setCount(cart.item_count);
      if(this.sub) this.sub.textContent = money(cart.total_price, this.currency);
      if(!cart.items || !cart.items.length){
        this.body.innerHTML = '<div class="dempty">Your bag is empty.</div>';
        return;
      }
      var cur = this.currency, html = '';
      cart.items.forEach(function(it){
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
        var opts = (it.options_with_values||[]).map(function(o){ return o.value; }).join(' / ');
        html += '<div class="ditem">'
          + (img ? '<img src="'+img+'" alt="'+ (it.product_title||'') +'">' : '')
          + '<div class="dmeta">'
          + '<h4>'+ it.product_title +'</h4>'
          + (opts ? '<div class="dv">'+opts+' &middot; Qty '+it.quantity+'</div>' : '<div class="dv">Qty '+it.quantity+'</div>')
          + '<div class="dpr">'+ money(it.final_line_price, cur) +'</div>'
          + '<a href="#" class="dremove" data-remove="'+it.key+'">Remove</a>'
          + '</div></div>';
      });
      this.body.innerHTML = html;
    },
    refresh: function(){
      var self = this;
      return fetch(window.Shopify.routes.root + 'cart.js', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(c){ self.render(c); return c; })
        .catch(function(){});
    },
    add: function(id, qty){
      var self = this;
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id: id, quantity: qty })
      }).then(function(r){ return r.json(); }).then(function(res){
        if(res.status){ throw res; }
        return self.refresh();
      });
    },
    change: function(key, qty){
      var self = this;
      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function(r){ return r.json(); }).then(function(c){ self.render(c); return c; });
    }
  };

  /* ---------- PDP ---------- */
  function initPDP(root){
    var cfgEl = document.getElementById(root.getAttribute('data-config'));
    if(!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var variants = cfg.variants || [];
    var qty = 1, current = 0, selectedVariant = null;

    var $ = function(sel){ return root.querySelector(sel); };
    var $$ = function(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    /* ----- gallery ----- */
    var images = cfg.images || [];
    var mainImg = $('[data-main-img]');
    var thumbBtns = $$('[data-thumb]');
    function setImg(i){
      if(!images.length) return;
      current = (i + images.length) % images.length;
      if(mainImg){ mainImg.src = images[current].full; mainImg.style.animation='none'; void mainImg.offsetWidth; mainImg.style.animation=''; }
      thumbBtns.forEach(function(t,k){ t.classList.toggle('on', k===current); });
    }
    thumbBtns.forEach(function(t,i){ t.addEventListener('click', function(){ setImg(i); }); });
    var prev = $('.js-prev'), next = $('.js-next');
    if(prev) prev.addEventListener('click', function(){ setImg(current-1); });
    if(next) next.addEventListener('click', function(){ setImg(current+1); });

    /* ----- price render (broadcast: PDP + sticky bar + closer + compare table) ----- */
    var docAll = function(sel){ return Array.prototype.slice.call(document.querySelectorAll(sel)); };
    var nowEls = docAll('.js-price'), saveEls = docAll('.js-save'), compareEls = docAll('.js-compare');
    var addBtns = docAll('.js-add');
    function renderPrice(v){
      var ref = v || variants[0] || {};
      var price = v ? v.price : cfg.minPrice;
      var compare = v ? v.compare_at : (ref.compare_at || 0);
      nowEls.forEach(function(e){ e.textContent = money(price, cfg.currency); });
      docAll('.js-price-sm').forEach(function(e){ e.textContent = money(price, cfg.currency); });
      if(compare && compare > price){
        compareEls.forEach(function(e){ e.textContent = money(compare, cfg.currency); e.style.display=''; });
        var pct = Math.round((1 - price/compare) * 100);
        saveEls.forEach(function(e){ e.textContent = 'Save '+pct+'%'; e.style.display=''; });
      } else {
        compareEls.forEach(function(e){ e.style.display='none'; });
        saveEls.forEach(function(e){ e.style.display='none'; });
      }
    }

    /* ----- variant selection ----- */
    var sizeSel = $('#sizeSel'), sizeHint = $('#sizeHint'), buynow = document.querySelector('.js-buynow');
    var idField = $('[data-variant-id]');
    function selectVariant(v){
      selectedVariant = v;
      if(idField) idField.value = v ? v.id : '';
      if(v){
        if(sizeSel){ sizeSel.textContent = v.title; sizeSel.classList.remove('warn'); }
        renderPrice(v);
        var avail = v.available;
        addBtns.forEach(function(b){ b.disabled = !avail; });
        if(sizeHint){
          sizeHint.classList.remove('warn');
          if(!avail){ sizeHint.textContent = v.title + ' is sold out.'; }
          else if(v.low){ sizeHint.textContent = 'Low stock in '+v.title+' — selling fast in the Raven drop.'; }
          else { sizeHint.textContent = cfg.sizeHint || 'True to size. Size down for a slimmer leg.'; }
        }
      }
    }
    $$('.size-tag').forEach(function(b){
      b.addEventListener('click', function(){
        if(b.classList.contains('soldout')) return;
        var vid = b.getAttribute('data-vid');
        var v = variants.filter(function(x){ return String(x.id)===String(vid); })[0];
        $$('.size-tag').forEach(function(x){ x.classList.toggle('on', x===b); });
        selectVariant(v);
      });
    });

    /* preselect: first available variant if only one option / single variant */
    if(variants.length === 1){
      var only = root.querySelector('.size-tag');
      if(only){ only.classList.add('on'); }
      selectVariant(variants[0]);
    } else {
      renderPrice(null);
    }

    function requireSize(){
      if(!selectedVariant){
        if(sizeSel){ sizeSel.textContent='Pick a size ↓'; sizeSel.classList.add('warn'); }
        if(sizeHint){ sizeHint.textContent='Select your size to add to bag.'; sizeHint.classList.add('warn'); }
        var sizes = $('#sizes'); if(sizes) sizes.scrollIntoView({behavior:'smooth',block:'center'});
        return false;
      }
      return true;
    }

    /* ----- qty ----- */
    var qtyVal = $('#qtyVal');
    function setQty(n){ qty = Math.max(1,n); if(qtyVal) qtyVal.textContent = qty; }
    var minus = $('.js-minus'), plus = $('.js-plus');
    if(minus) minus.addEventListener('click', function(){ setQty(qty-1); });
    if(plus)  plus.addEventListener('click', function(){ setQty(qty+1); });

    /* ----- add to cart ----- */
    addBtns.forEach(function(b){
      b.addEventListener('click', function(e){
        e.preventDefault();
        if(!requireSize()) return;
        b.disabled = true;
        Cart.add(selectedVariant.id, qty).then(function(){
          b.disabled = false;
          Cart.open();
        }).catch(function(err){
          b.disabled = false;
          if(sizeHint){ sizeHint.textContent = (err && err.description) ? err.description : 'Could not add to bag.'; sizeHint.classList.add('warn'); }
        });
      });
    });

    if(buynow){
      buynow.addEventListener('click', function(e){
        e.preventDefault();
        if(!requireSize()) return;
        buynow.disabled = true;
        Cart.add(selectedVariant.id, qty).then(function(){
          window.location.href = window.Shopify.routes.root + 'checkout';
        }).catch(function(){ buynow.disabled = false; });
      });
    }

    /* ----- size guide modal ----- */
    var modal = document.getElementById('sable-size-modal');
    if(modal){
      docAll('.js-sizeguide').forEach(function(b){ b.addEventListener('click', function(){ modal.classList.add('show'); }); });
      modal.querySelectorAll('.js-close-size').forEach(function(b){ b.addEventListener('click', function(){ modal.classList.remove('show'); }); });
      modal.addEventListener('click', function(e){ if(e.target===modal) modal.classList.remove('show'); });
      document.addEventListener('keydown', function(e){ if(e.key==='Escape') modal.classList.remove('show'); });
    }

    /* ----- sticky mobile bar ----- */
    var stick = document.getElementById('sable-stick');
    var qrow = $('.qrow');
    if(stick && qrow && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(ents){
        ents.forEach(function(en){ stick.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }, {threshold:0});
      io.observe(qrow);
    }

    /* ----- launch countdown ----- */
    var launchEnd = cfg.launchEnd ? new Date(cfg.launchEnd).getTime() : 0;
    if(launchEnd){
      var elH=$('#cdH'), elM=$('#cdM'), elS=$('#cdS');
      var anno=document.getElementById('annoCd');
      var pad=function(n){ return (n<10?'0':'')+n; };
      var timer;
      function tick(){
        var diff = launchEnd - Date.now();
        if(diff<=0){
          var l=$('#launch'); if(l) l.classList.add('ended');
          var pre=$('#cdPre'); if(pre) pre.textContent='Sale ended';
          var rise=$('.launch__rise'); if(rise) rise.textContent='Back at full price';
          if(elH)elH.textContent='00'; if(elM)elM.textContent='00'; if(elS)elS.textContent='00';
          if(anno) anno.textContent='ended';
          var sl=$('#stockLeft'); if(sl && cfg.flipStockText) sl.textContent='Offer closed';
          if(timer) clearInterval(timer);
          return;
        }
        var h=Math.floor(diff/3600000), m=Math.floor((diff%3600000)/60000), s=Math.floor((diff%60000)/1000);
        if(elH)elH.textContent=pad(h); if(elM)elM.textContent=pad(m); if(elS)elS.textContent=pad(s);
        if(anno) anno.textContent=pad(h)+':'+pad(m)+':'+pad(s);
      }
      tick(); timer=setInterval(tick,1000);
    }
  }

  ready(function(){
    Cart.init();
    document.querySelectorAll('[data-sable-pdp]').forEach(initPDP);
  });
})();
